module.exports = __webpack_public_path__ + "img/banner2.514aa8c5.png";